import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../../data/testimonials';
import { CTAButton } from '../CTAButton';
export function Testimonials() {
  return <section className="w-full bg-white py-14 md:py-20" aria-labelledby="testimonials-title" data-id="element-255" data-mp="3mgafkkhj9ipu">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-256" data-mp="3r7905w9k12yw">
        <h2 id="testimonials-title" className="text-center font-display text-[26px] font-black uppercase leading-tight tracking-tight text-navy-950 sm:text-4xl" data-id="element-257" data-mp="3r8ttxjo1ohvp">
          What Professionals Are Saying
        </h2>

        <ul className="mt-8 grid gap-4 md:mt-12 md:grid-cols-2 md:gap-6" data-id="element-258" data-mp="91e45e0xrhej">
          {testimonials.map(item => <li key={item.name} className="flex flex-col rounded-3xl border border-navy-900/10 bg-mist px-5 py-6 shadow-card sm:px-6" data-id="element-259" data-mp="e18rx8pezqvd">
              <div className="flex items-center gap-1" aria-label="5 out of 5 stars" data-id="element-260" data-mp="2fs3qu9ex466b">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-261" data-mp="1sm3x3xce0agp" data-mpi={i} />)}
              </div>

              <QuoteIcon className="mt-4 h-6 w-6 text-brand-400" aria-hidden="true" data-id="element-262" data-mp="1iugcoge8ztoq" />
              <blockquote className="mt-2 flex-1 text-[15px] font-medium leading-relaxed text-navy-900" data-id="element-263" data-mp="1isdakxztma3n">
                “{item.quote}”
              </blockquote>

              <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-264" data-mp="2bive204gidhl">
                <img src={item.photo} alt={`Portrait of ${item.name}`} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-white" width={112} height={112} loading="lazy" data-id="element-265" data-mp="26k29ix75dwtk" />
                <div data-id="element-266" data-mp="r4l8xepn81gj">
                  <p className="font-display text-[14px] font-black uppercase tracking-wide text-navy-950" data-id="element-267" data-mp="r4v2tddt6sri">
                    {item.name}
                  </p>
                  <p className="text-[12px] font-semibold text-navy-800/60" data-id="element-268" data-mp="nlcq24hig4ew">{item.country}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-xl text-center" data-id="element-269" data-mp="eky18v5c876n">
          <p className="font-display text-lg font-black uppercase leading-tight text-navy-950 sm:text-2xl" data-id="element-270" data-mp="ekod7d3usa3l">
            Organize your next case with a system.
          </p>
          <div className="mt-6" data-id="element-271" data-mp="4u3elpo6j5ko">
            <CTAButton data-id="element-272" data-mp="4t1t0r9jf0op" />
          </div>
        </div>
      </div>
    </section>;
}